import { useQuery, gql } from '@apollo/client';

const GET_QUOTA = gql`
  query CheckQuota {
    aiDrillGenerationQuota {
      subscriptionTier
      generatedToday
      generatedThisMonth
      dailyLimit
      monthlyLimit
      remainingToday
      remainingThisMonth
      canGenerate
      resetDate
    }
  }
`;

export function useQuota() {
  const { data, loading, error, refetch } = useQuery(GET_QUOTA);

  // Debug: log raw response to help trace issues between backend and client
  /* istanbul ignore next */
  if (process.env.NODE_ENV !== 'production') {
    console.debug('[useQuota] raw data:', data);
    console.debug('[useQuota] error:', error);
    console.debug('[useQuota] parsed quota:', data?.aiDrillGenerationQuota);
  }

  // Fallback quota in case of error (e.g., invalid user ID on backend)
  const fallbackQuota = {
    subscriptionTier: 'FREE',
    generatedToday: 0,
    generatedThisMonth: 0,
    dailyLimit: 5,
    monthlyLimit: 20,
    remainingToday: 5,
    remainingThisMonth: 20,
    canGenerate: true,
    resetDate: new Date(Date.now() + 24 * 60 * 60 * 1000).toISOString(),
  };

  return {
    quota: data?.aiDrillGenerationQuota || (error ? fallbackQuota : null),
    loading,
    error,
    refetch,
  };
}
